import React, { useState, useEffect } from "react";
import api from "../utils/api";
import { toast } from "react-toastify";

const SavedCards = () => {
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    cardholderName: "",
    cardNumber: "",
    expiryDate: "",
    cardType: "Debit",
    cvv: "",
    _id: null,
  });

  useEffect(() => {
    fetchCards();
  }, []);

  const fetchCards = async () => {
    try {
      const res = await api.get("/cards");
      setCards(res.data);
    } catch (err) {
      console.error(err);
      toast.error("Failed to fetch cards");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // ✅ ADD THIS BLOCK
  if (
    !form.cardholderName ||
    !form.cardNumber ||
    !form.expiryDate
  ) {
    toast.error("Please fill all required fields");
    return;
  }

  if (form.cardNumber.length < 12) {
    toast.error("Invalid card number");
    return;
  }

    setLoading(true);

    try {
      if (form._id) {
        await api.put(`/cards/${form._id}`, {
          cardholderName: form.cardholderName,
          cardNumber: form.cardNumber,
          expiryDate: form.expiryDate,
          cardType: form.cardType,
        });
        toast.success("Card updated");
      } else {
        await api.post("/cards", {
          cardholderName: form.cardholderName,
          cardNumber: form.cardNumber,
          expiryDate: form.expiryDate,
          cardType: form.cardType,
        });
        toast.success("Card added");
      }

      setForm({
        cardholderName: "",
        cardNumber: "",
        expiryDate: "",
        cardType: "Debit",
        cvv: "",
        _id: null,
      });

      fetchCards();
    } catch (err) {
      console.error(err);
      toast.error("Failed to save card");
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (card) => {
    setForm({
      cardholderName: card.cardholderName,
      cardNumber: card.cardNumber,
      expiryDate: card.expiryDate,
      cardType: card.cardType,
      cvv: "",
      _id: card._id,
    });

    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleDelete = async (_id) => {
    if (!window.confirm("Are you sure you want to delete this card?")) return;

    try {
      await api.delete(`/cards/${_id}`);
      toast.success("Card deleted");
      fetchCards();
    } catch (err) {
      console.error(err);
      toast.error("Failed to delete card");
    }
  };

  const maskCard = (num) => "**** **** **** " + num.slice(-4);

  return (
    <div className="saved-cards-container">
      {/* Form */}
      <div className="card-form">
        <h2>{form._id ? "Edit Card" : "Add Card"}</h2>

        <form onSubmit={handleSubmit}>
          <div className="form-field">
            <label>Cardholder Name</label>
            <input
              type="text"
              name="cardholderName"
              value={form.cardholderName}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-field">
            <label>Card Number</label>
            <input
              type="text"
              name="cardNumber"
              value={form.cardNumber}
              onChange={handleChange}
              maxLength="16"
              required
            />
          </div>

          <div className="form-field">
            <label>Expiry Date (MM/YY)</label>
            <input
              type="text"
              name="expiryDate"
              value={form.expiryDate}
              onChange={handleChange}
              placeholder="MM/YY"
              required
            />
          </div>

          <div className="form-field">
            <label>Card Type</label>
            <select
              name="cardType"
              value={form.cardType}
              onChange={handleChange}
            >
              <option value="Debit">Debit</option>
              <option value="Credit">Credit</option>
            </select>
          </div>

          <div className="form-field">
            <label>CVV</label>
            <input
              type="password"
              name="cvv"
              value={form.cvv}
              onChange={handleChange}
              maxLength="4"
            />
          </div>

          <button type="submit" disabled={loading}>
            {loading
              ? "Saving..."
              : form._id
              ? "Update Card"
              : "Add Card"}
          </button>
        </form>
      </div>

      {/* Cards List */}
      <div className="cards-list">
        {cards.length > 0 ? (
          cards.map((card) => (
            <div className="card" key={card._id}>
              <div className="card-info">
                <p><strong>Name:</strong> {card.cardholderName}</p>
                <p><strong>Number:</strong> {maskCard(card.cardNumber)}</p>
                <p><strong>Expiry:</strong> {card.expiryDate}</p>
                <p><strong>Type:</strong> {card.cardType}</p>
              </div>

              <div className="card-actions">
                <button
                  className="edit-btn"
                  onClick={() => handleEdit(card)}
                >
                  ✏️ Edit
                </button>

                <button
                  className="delete-btn"
                  onClick={() => handleDelete(card._id)}
                >
                  🗑️ Delete
                </button>
              </div>
            </div>
          ))
        ) : (
          <p className="no-cards">No cards saved yet.</p>
        )}
      </div>
    </div>
  );
};

export default SavedCards;